import { render, staticRenderFns } from "./CopyrightEscalationFile.vue?vue&type=template&id=0c7ebb84&scoped=true&"
import script from "./CopyrightEscalationFile.vue?vue&type=script&lang=js&"
export * from "./CopyrightEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightEscalationFile.vue?vue&type=style&index=0&id=0c7ebb84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ebb84",
  null
  
)

export default component.exports